import { defaultSettings, mergeSettings } from "./settings";
const LS_KEY = "md2bookpdf:settings:v1";
export function loadSettingsFromStorage() {
    try {
        const raw = localStorage.getItem(LS_KEY);
        if (!raw)
            return defaultSettings();
        const parsed = JSON.parse(raw);
        return mergeSettings(defaultSettings(), parsed);
    }
    catch {
        return defaultSettings();
    }
}
export function saveSettingsToStorage(settings) {
    try {
        localStorage.setItem(LS_KEY, JSON.stringify(settings));
    }
    catch {
        /* localStorage voll oder gesperrt — ignorieren */
    }
}
export function exportSettingsAsFile(settings, filename = "md2bookpdf-settings.json") {
    const blob = new Blob([JSON.stringify(settings, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        URL.revokeObjectURL(url);
        a.remove();
    }, 0);
}
export async function importSettingsFromFile(file) {
    const text = await file.text();
    const parsed = JSON.parse(text);
    if (parsed.version !== 1) {
        // Künftig: Migrationspfade. Für jetzt: defensiv mergen.
        console.warn("Settings-Version unbekannt, versuche zu mergen:", parsed.version);
    }
    return mergeSettings(defaultSettings(), parsed);
}
